import React, { useEffect } from "react";
import { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import "./PauseScreenBubble.css";

function PauseScreenBubble(props) {
  let handleClose = props.handleClose;
  let handleResume = props.handleResume;
  // let setBgAudioIsPlaying = props.setBgAudioIsPlaying;
  // let bgAudioIsPlaying = props.bgAudioIsPlaying;
  // let setMmAudioIsPlaying = props.setMmAudioIsPlaying;
  let navigate = useNavigate();
  let location = useLocation();

  function handleEnd(event) {
    event.preventDefault();

    // There should only be one key/value pair in localStorage
    // so we can be lazy and just call clear()
    localStorage.clear();

    navigate("/");
  }

  return (
    <div>
      <div className="top-row">
        <div className="left-col">
          <div className="bubble-container">
            <img
              className="speech-bubble"
              src="assets/imgs/pause-speech-bubble.svg"
            ></img>
            <div className="speech-bubble-content">
              <p> You have Paused the Assessment!</p>
              <p>
                {" "}
                <img
                  className="bubble-img"
                  src="assets/imgs/small-resume-button.svg"
                ></img>
                Press the Play button to continue the Assessment
              </p>
              <p class="image-text-container">
                <img
                  className="bubble-img"
                  src="assets/imgs/small-end-assessment-button.svg"
                ></img>
                {/* Press the Stop button to Save the<br></br> Assessment and
                continue later */}
                Press the Stop button to Save and restart <br></br>
                from the beginning of this task next time.
                 </p>
            </div>
          </div>
          <div className="big-button-container">
            <div className="button-container">
              <img
                className="button-background"
                src="assets/imgs/Tasks-assets-background.svg"
              ></img>

              <button
                id="resume-button"
                onClick={() => {
                  handleClose();
                  handleResume();
                }}
              >
                <img
                  className="resume-button"
                  src="assets/imgs/resume-button.svg"
                ></img>
              </button>
            </div>
            <div className="button-container">
              <img
                className="button-background"
                src="assets/imgs/Tasks-assets-background.svg"
              ></img>
              <button onClick={handleEnd}>
                <img
                  className="end-assessment-button"
                  src="assets/imgs/end-assessment-button.png"
                ></img>
              </button>
            </div>
          </div>
        </div>
        <div className="alpaca-img-container">
          <img className="alpaca-img" src="assets/imgs/Alpaca-straw.svg"></img>
        </div>
      </div>
    </div>
  );
}

export default PauseScreenBubble;
